import { css } from "@emotion/css";
import { useRef } from "react";
import { AriaModalOverlayProps, Overlay, useModalOverlay } from "react-aria";
import { OverlayTriggerState } from "react-stately";

import { useMediaQuery } from "../../components/utils";
interface ModalProps extends AriaModalOverlayProps {
  children?: React.ReactNode;
  state: OverlayTriggerState;
  testID?: string;
}

export function ModalOverlay({
  state,
  children,
  testID = "modal-overlay",
  ...props
}: ModalProps) {
  const ref = useRef<HTMLDivElement>(null);
  const { modalProps, underlayProps } = useModalOverlay(props, state, ref);
  const { mediaQuery } = useMediaQuery();

  return (
    <Overlay>
      <div
        className={css(styles.underlay, {
          backgroundColor: "var(--surface-modal)",
        })}
        data-testid={testID}
        {...underlayProps}
      >
        <div
          {...modalProps}
          className={css(
            mediaQuery({
              margin: ["auto auto 0 auto", "auto"],
            })
          )}
          ref={ref}
        >
          {children}
        </div>
      </div>
    </Overlay>
  );
}

const styles = {
  underlay: css({
    position: "fixed",
    zIndex: 100,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
  }),
};
